import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import PaymentMethodModal from "../components/Modal/PaymentMethodModal";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import Calendar from "react-calendar";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useAvailability } from "../hooks/useAvailability";
import { UpdateSelectedActivitiesModal } from "../components/availability/UpdateSelectedActivitiesModal";
import { FormControlLabel, FormGroup, Switch, TextField } from "@mui/material";
import {
  Modal,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

type AvailabilityProps = {
  handleAddAvailablity?: () => void;
  onUpdateActivities?: () => void;
};

const mockAvailability = [
  {
    id: 1,
    title: "Tour 1",
    options: { id: 1, title: "Option 1" },
    date: new Date(),
    participants: 2,
    maxParticipants: 10,
    cutOff: "2 hours before",
    isBookable: true,
    availableSpots: 8,
  },
  {
    id: 2,
    title: "Tour 2",
    options: { id: 2, title: "Option 2" },
    date: new Date(),
    participants: 2,
    maxParticipants: 10,
    cutOff: "2 hours before",
    isBookable: false,
    availableSpots: 0,
  },
];

const AvailabilityPage: React.FC<AvailabilityProps> = () => {
  const { getAvailability, addAvailability } = useAvailability();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [date, setDate] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [availability, setAvailability] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5);
  const [available, setAvailable] = useState<boolean>(true);
  const [isCutoffModalOpen, setIsCutoffModalOpen] = useState(false);
  const [selectedCutoffTour, setSelectedCutoffTour] = useState<any>(null);
  const [cutoffTime, setCutoffTime] = useState("");
  const [isMaxParticipantsModalOpen, setIsMaxParticipantsModalOpen] =
    useState(false);
  const [selectedMaxParticipantsTour, setSelectedMaxParticipantsTour] =
    useState<any>(null);
  const [maxParticipants, setMaxParticipants] = useState<number | "">("");
  const [editedBlockDate, setEditedBlockDate] = useState<{
    [key: string]: boolean;
  }>({});

  const handleAddAvailablity = () => {
    setIsModalOpened(true);
  };

  const closeModal = () => {
    setIsModalOpened(false);
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const onDateChange = (date: any) => {
    setSelectedDate(date);
    setDate(date.toLocaleDateString());
    setShowCalendar(false);
  };

  useEffect(() => {
    const fetchAvailability = async () => {
      setLoading(true);
      const response = await getAvailability(page, limit, available);
      const normalizedData = (response.availability || mockAvailability).map(
        (item: { id?: string; _id?: string; blockDate?: boolean }) => ({
          ...item,
          id: item.id ?? item._id, // Normalize `id` field
          blockDate: item.blockDate ?? false, // Ensure blockDate is set
        })
      );
      setAvailability(normalizedData);
      setLoading(false);
    };
    fetchAvailability();
  }, [page, limit, available]);

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      setSelectedOptions(availability.map((t) => t.id));
    } else {
      setSelectedOptions([]);
      console.log("selected options", selectedOptions);
    }
  };

  const handleCheckboxChange =
    (id: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked;
      let updatedSelectedOptions = [];

      if (checked) {
        updatedSelectedOptions = [...selectedOptions, id];
      } else {
        updatedSelectedOptions = selectedOptions.filter(
          (itemId) => itemId !== id
        );
      }

      setSelectedOptions(updatedSelectedOptions);

      // Update 'selectAll' manually
      if (updatedSelectedOptions.length === availability.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const availabilityCount = availability.length;
  console.log("availability", availability);

  const handleBlockDate =
    (id: string) => async (e: React.ChangeEvent<HTMLInputElement>) => {
      const isBlocked = e.target.checked;
      setAvailability((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, blockDate: isBlocked } : item
        )
      );

      const payload = {
        packageId: [id],
        blockDate: isBlocked,
      };
      try {
        const response = await addAvailability(payload);
        if (response.status === 200) {
          console.log(`Block date updated for package ID: ${id}`);
        } else {
          console.error("Failed to update block date:", response.message);
        }
      } catch (error) {
        console.error("Error updating block date:", error);
      }
    };

  const handleOpenCutoffModal = (tour: any) => {
    setSelectedCutoffTour(tour);
    setCutoffTime(tour.cutOff);
    setIsCutoffModalOpen(true);
  };

  const handleCloseCutoffModal = () => {
    setIsCutoffModalOpen(false);
    setSelectedCutoffTour(null);
  };

  const handleSaveCutoffTime = async () => {
    if (selectedCutoffTour) {
      const payload = {
        packageId: [selectedCutoffTour._id],
        cutOff: cutoffTime,
      };
      try {
        const response = await addAvailability(payload);
        if (response.status === 200) {
          console.log(`Cutoff time updated for ${selectedCutoffTour.title}`);
        } else {
          console.error("Failed to update cutoff time:", response.message);
        }
      } catch (error) {
        console.error("Error updating cutoff time:", error);
      }
    }
    handleCloseCutoffModal();
  };

  const handleOpenMaxParticipantsModal = (tour: any) => {
    setSelectedMaxParticipantsTour(tour);
    setMaxParticipants(tour.maxParticipants);
    setIsMaxParticipantsModalOpen(true);
  };

  const handleCloseMaxParticipantsModal = () => {
    setIsMaxParticipantsModalOpen(false);
    setSelectedMaxParticipantsTour(null);
  };

  const handleSaveMaxParticipants = async () => {
    if (selectedMaxParticipantsTour) {
      const payload = {
        packageId: [selectedMaxParticipantsTour._id],
        maxParticipants,
      };
      try {
        const response = await addAvailability(payload);
        if (response.status === 200) {
          console.log(
            `Max participants updated for ${selectedMaxParticipantsTour.title}`
          );
        } else {
          console.error("Failed to update max participants:", response.message);
        }
      } catch (error) {
        console.error("Error updating max participants:", error);
      }
    }
    handleCloseMaxParticipantsModal();
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-7xl mx-auto min-h-screen px-0 sm:px-4 lg:px-0">
        <div className="flex sm:flex-row sm:justify-between items-center mt-6">
          <h1 className="text-xl sm:text-2xl font-semibold mt-6">
            Availability
          </h1>
          {/* <button
            className="mt-4 sm:mt-0 text-blue-600 font-semibold flex items-center"
            onClick={handleAddAvailablity}
          >
            <span className="text-xl">+</span> Add availability
          </button> */}
        </div>

        {/* {isModalOpened && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 w-full sm:w-2/3 lg:w-1/3">
              <div className="flex justify-between items-center">
                <h2 className="text-lg sm:text-xl font-semibold">
                  Add availabilities
                </h2>
                <button onClick={closeModal} className="text-gray-600">
                  <CloseOutlinedIcon />
                </button>
              </div>
              <div className="mt-4">
                <label className="block text-sm font-bold mb-2">Tour</label>
                <input
                  type="text"
                  placeholder="Product name"
                  className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex justify-end mt-6">
                <button
                  onClick={closeModal}
                  className="px-4 py-2 mr-2 text-blue-600 font-semibold"
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 text-white bg-gray-400 rounded-lg cursor-not-allowed"
                  disabled
                >
                  Add availability
                </button>
              </div>
            </div>
          </div>
        )} */}

        <div className="bg-gray-50 rounded-lg p-4 sm:p-8 flex flex-col sm:flex-row">
          <div className="w-full sm:w-1/3 p-4 bg-white mb-4 sm:mb-0">
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4">Other links</h2>
              <a
                href="#calendar"
                onClick={(e) => {
                  e.preventDefault();
                  toggleCalendar();
                }}
                className="text-blue-600 flex items-center space-x-2 cursor-pointer"
              >
                <CalendarMonthIcon />
                <span>Go to calendar view</span>
              </a>
            </div>

            <div className="mb-7">
              <p className="block text-sm font-bold mb-1">Filter by product</p>
              <div className="relative">
                <SearchOutlinedIcon className="absolute top-2 left-2 text-gray-400" />
                <input
                  id="product-name"
                  type="text"
                  placeholder="Product name"
                  className="border border-gray-300 rounded pl-8 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="mb-7">
              <p className="block text-sm font-bold mb-1">Filter by option</p>
              <div className="relative">
                <SearchOutlinedIcon className="absolute top-2 left-2 text-gray-400" />
                <input
                  id="option-name"
                  type="text"
                  placeholder="Option name"
                  className="border border-gray-300 rounded pl-8 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="mb-7">
              <p className="block text-sm font-bold mb-1">Filter by date</p>
              <div className="flex items-center mb-4 relative">
                <input
                  type="text"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  placeholder="Select date"
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => (e.target.type = "text")}
                  className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                  id="date"
                />
                <KeyboardArrowDownOutlinedIcon className="absolute right-3 text-gray-400 pointer-events-none" />
              </div>
            </div>

            <div>
              <p className="block text-sm font-bold mb-2">Show booked</p>
              <div className="flex items-center ml-3">
                <input
                  id="booked-only"
                  type="checkbox"
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <p className="block text-sm mb-1 ml-2">Booked only</p>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="w-full sm:w-2/3 px-4 sm:px-5">
            <div className="flex items-center bg-white p-4 sm:p-7">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  id="selectAll"
                  className="h-4 sm:h-8 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-300"
                />
                {/* Label for the checkbox */}
                <label
                  htmlFor="selectAll"
                  className="ml-2 text-sm sm:text-base text-gray-700 cursor-pointer"
                >
                  Select all ({availabilityCount})
                </label>
              </div>

              <button
                onClick={handleClick}
                className="ml-auto text-blue-600 font-semibold"
              >
                Update selected activities
              </button>
              <UpdateSelectedActivitiesModal
                anchorEl={anchorEl}
                open={open}
                handleClose={handleClose}
                selectedCount={selectedOptions.length}
                selectedOptions={selectedOptions}
              />
            </div>
            {/* availability list  */}
            {loading ? (
              <div className="text-center">Loading...</div>
            ) : (
              <div>
                {availability.length > 0 ? (
                  availability.map((tour) => (
                    <div
                      key={tour._id}
                      className="p-4 border border-gray-300 rounded-lg flex flex-col sm:flex-row gap-4 sm:gap-8 mb-4"
                    >
                      <div className="flex">
                        <input
                          checked={selectedOptions.includes(
                            tour.id || tour._id
                          )}
                          onChange={handleCheckboxChange(tour.id || tour._id)}
                          type="checkbox"
                          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <label
                          htmlFor={`tour-${tour.id}`}
                          className="ml-2 text-sm sm:text-base text-gray-700 cursor-pointer"
                        >
                          {/* {tour?.date.toLocaleDateString()} */}
                          <div>08:00</div>
                        </label>
                      </div>
                      <div className="flex-grow text-center sm:text-left flex flex-col sm:flex-row justify-between sm:items-start">
                        <div>
                          <h3 className="font-semibold">{tour?.title}</h3>
                          <p className="text-md">
                            Option: {tour?.options?.title}
                          </p>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={
                                    editedBlockDate[tour.id || tour._id] ??
                                    tour.blockDate ??
                                    false
                                  }
                                  onChange={(e) =>
                                    handleBlockDate(tour.id || tour._id)(e)
                                  }
                                  name={`blockDate-${tour._id}`}
                                />
                              }
                              label="Block Date"
                            />
                          </FormGroup>
                          <div className="text-md flex gap-2">
                            CutOff : {tour?.cutOff}
                            <button
                              className="text-primary1"
                              onClick={() => handleOpenCutoffModal(tour)}
                            >
                              Edit
                            </button>
                          </div>
                          <div className="text-md flex gap-2">
                            {tour.participants}/{tour.maxParticipants}{" "}
                            Participants({tour.availableSpots} spots left)
                            <button
                              className="text-primary1"
                              onClick={() =>
                                handleOpenMaxParticipantsModal(tour)
                              }
                            >
                              Update availability
                            </button>
                          </div>
                        </div>
                        <div
                          className={`${
                            tour.available ? "bg-green-200" : "bg-gray-200"
                          }  p-2 rounded-lg w-full max-w-[120px] text-center`}
                        >
                          {tour.available ? "Bookable" : "Not Bookable"}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center">No product availability found</p>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Calendar Modal */}
        {showCalendar && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full sm:w-auto">
              <h2 className="text-lg sm:text-xl font-semibold mb-4">
                Select a Date
              </h2>
              <Calendar onChange={onDateChange} value={selectedDate} />
              <button
                onClick={() => setShowCalendar(false)}
                className="mt-4 px-4 py-2 text-blue-600 font-semibold"
              >
                Close
              </button>
            </div>
          </div>
        )}
        {/* Cutoff Time Modal */}
        <Modal open={isCutoffModalOpen} onClose={handleCloseCutoffModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 300,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: "20px", marginBottom: "16px" }}
            >
              Edit Cutoff Time
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel id="cutoff-time-label">Cutoff Time</InputLabel>
              <Select
                labelId="cutoff-time-label"
                value={cutoffTime}
                label="Cutoff Time"
                onChange={(e) => setCutoffTime(e.target.value)}
              >
                <MenuItem value="15m">15 minutes</MenuItem>
                <MenuItem value="30m">30 minutes</MenuItem>
                <MenuItem value="1h">1 hour</MenuItem>
                <MenuItem value="2h">2 hours</MenuItem>
              </Select>
            </FormControl>
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button onClick={handleCloseCutoffModal} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#1E61DC" }}
                onClick={handleSaveCutoffTime}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* Max Participants Modal */}
        <Modal
          open={isMaxParticipantsModalOpen}
          onClose={handleCloseMaxParticipantsModal}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 300,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: "20px", marginBottom: "16px" }}
            >
              Update Max Participants
            </Typography>
            <FormControl fullWidth size="small">
              <TextField
                type="number"
                value={maxParticipants}
                onChange={(e) => setMaxParticipants(Number(e.target.value))}
                label="Max Participants"
                placeholder="Enter max participants"
              />
            </FormControl>
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button onClick={handleCloseMaxParticipantsModal} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#1E61DC" }}
                onClick={handleSaveMaxParticipants}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </div>
  );
};

export default AvailabilityPage;
